import * as React from "react";
import IRepertoireComponentDataItem from "../../../redux/types/IRepertoireComponentDataItem";
import { IValidationMessage } from "../../types/IValidationMessage";
import { MessageBanner, MessageType } from "../messageBanner/MessageBanner";
import { WORK_MAINTENANCE_TOOLBAR, PRODUCT_MAINTENANCE_TOOLBAR, IP_MAINTENANCE_TOOLBAR, LICENSE_MAINTENANCE_TOOLBAR, AGREEMENT_MAINTENANCE_TOOLBAR, ADJUSTMENT_MAINTENANCE_TOOLBAR, JOB_CREATED_VIEW } from "../../Consts";
import IMembersPortalComponentDataItem from "../../../redux/types/IMembersPortalComponentDataItem";
import { IAgreementWorksFromPackageJobResponse } from "../../types/IAgreementWorksFromPackageJobResponse";
import { isNullOrUndefined } from "../../../util/tools";
import { showModal } from "../../../redux/reducers/ModalReducer";
import { connect } from "react-redux";
import { useEffect } from "react";

export interface ISaveResultProps {
    componentInstance: string;
    saveSuccess?: boolean;
    postSuccess?: boolean;
    matchingSuccess?: boolean;
    saveResultData: IRepertoireComponentDataItem | IMembersPortalComponentDataItem;
    messages: IValidationMessage[];
    deleteAccount?: boolean;
    mergeSuccess?: boolean;
    addRepresentationSuccessful?: boolean;
    exportSuccess?: boolean;
    newAllocateDistributionPoolsJobSuccess?: boolean;
    allocationJobInProgress?: boolean;
    resetMessageBanner: () => void;
    newBookPriceCalculationsJobSuccess?: boolean;
    bookPriceCalculationsJobInProgress?: boolean;
    agreementWorksFromPackageJobSuccess?: boolean;
    agreementWorksFromPackageJobResult?: IAgreementWorksFromPackageJobResponse;
    processClaimJobSuccess?: boolean;
    mergeAgreementSuccess?: boolean;
    showModal?: typeof showModal;
    newAllocateDistributionConfirmationShow?: boolean;
    isUndo?: boolean;
}

const SaveResult: React.FC<ISaveResultProps> = ({
    saveSuccess,
    postSuccess,
    matchingSuccess,
    saveResultData,
    deleteAccount,
    mergeSuccess,
    exportSuccess,
    resetMessageBanner,
    componentInstance,
    addRepresentationSuccessful,
    newAllocateDistributionPoolsJobSuccess,
    allocationJobInProgress,
    newBookPriceCalculationsJobSuccess,
    bookPriceCalculationsJobInProgress,
    processClaimJobSuccess,
    agreementWorksFromPackageJobSuccess,
    agreementWorksFromPackageJobResult,
    messages,
    mergeAgreementSuccess,
    showModal,
    newAllocateDistributionConfirmationShow,
    isUndo
}) => {

    useEffect(() => {
        if (newAllocateDistributionConfirmationShow) {
            const fields = (saveResultData?.fields ?? []) as { name: string; data: string; }[];

            const messages: string[] = isUndo ? [fields.find(x => x.name.toString() === 'newUndoAllocateDistributionPoolsJobSuccessMessage').data] : [fields.find(x => x.name.toString() === 'newAllocateDistributionPoolsJobSuccessMessage').data];

            showModal(
                JOB_CREATED_VIEW,
                null,
                { textToScreen: messages[0] },
                true,
                "Allocate"
            );
        }
    }, [ newAllocateDistributionConfirmationShow, saveResultData, showModal ]);

    const renderValidationMessages = (): string[] => {
        const validationMessages: string[] = [];
        const fields = saveResultData?.fields as { name: any; data: string }[];
        if (messages && Array.isArray(messages) && messages.length) {
            messages.forEach(e => {
                if (!e || !e.messageKey || typeof e.messageKey !== 'string') {
                    return;
                }
                else if (e.messageKey.includes('AgreementValidationWithID')) {
                    e.messageKey = e.messageKey.replace('AgreementValidationWithID: ', '');
                    validationMessages.push(e.messageKey);
                }
                else {
                    try {
                        let message = "";
                        if (saveResultData && saveResultData.fields && Array.isArray(saveResultData.fields)) {
                            const fields = saveResultData?.fields as { name: any; data: string }[];
                            message = fields?.find(x => x.name.toString() === e.messageKey)?.data ?? e.messageKey;
                        }
                        if (e.additionalInfo) {
                            if (e.additionalInfo.startsWith('<') && e.additionalInfo.endsWith('>')) {
                                var formatValuesArray = e.additionalInfo.substring(1, e.additionalInfo.length - 1).split(',')

                                for (let i = 0; i < formatValuesArray.length; i++) {
                                    message = message.replace("<" + i + ">", formatValuesArray[i])
                                }
                            }
                            else {
                                message = message + ' ' + e.additionalInfo;
                            }

                        }
                        validationMessages.push(message);
                    }
                    catch (error) {
                        let message = e.messageKey
                        if (e.additionalInfo) {
                            message = message + ' ' + e.additionalInfo;
                        }
                        validationMessages.push(message);
                    }
                }
            })
        }
        else {
            validationMessages.push(fields.find(x => x.name.toString() === 'saveFailedMessage').data);
        }

        return validationMessages;
    };

    const fields = saveResultData?.fields as { name: any; data: string }[];

    if (isNullOrUndefined(postSuccess) && isNullOrUndefined(saveSuccess) 
        && isNullOrUndefined(matchingSuccess) && isNullOrUndefined(agreementWorksFromPackageJobSuccess)) {
        return <div />;
    }
    else if (postSuccess === false || saveSuccess === false || matchingSuccess === false) {
        if(componentInstance === "WorkMaintenanceAccordionView") {
            return <div className="workMessageBanner"><MessageBanner
                resetMessageBanner={resetMessageBanner}
                messageType={MessageType.Danger}
                messages={renderValidationMessages()} /></div>
        } else {
            return <MessageBanner
                resetMessageBanner={resetMessageBanner}
                messageType={MessageType.Danger}
                messages={renderValidationMessages()} />
        }
    }
    else if (matchingSuccess && componentInstance !== IP_MAINTENANCE_TOOLBAR) {
        return <MessageBanner
            resetMessageBanner={resetMessageBanner}
            messageType={MessageType.Success}
            messages={renderValidationMessages()} />
    }
    else if (componentInstance === ADJUSTMENT_MAINTENANCE_TOOLBAR && messages?.length === 1 && messages[0]?.messageKey === 'adjustmentBatchPostSuccessMessage') {
        const batchPostMessage = fields.find(x => x.name.toString() === 'adjustmentBatchPostSuccessMessage')?.data ?? 'Adjustment batch posted.';
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={[batchPostMessage]} />
    }
    else if (postSuccess && componentInstance !== IP_MAINTENANCE_TOOLBAR) {

        let postSuccessMessage: string;
        if (componentInstance === WORK_MAINTENANCE_TOOLBAR) {
            postSuccessMessage = 'workPostSuccessMessage';
        } else if (componentInstance === PRODUCT_MAINTENANCE_TOOLBAR) {
            postSuccessMessage = 'productPostSuccessMessage';
        } else if (componentInstance === ADJUSTMENT_MAINTENANCE_TOOLBAR){
            postSuccessMessage = 'adjustmentPostSuccessMessage';
        } else {
            postSuccessMessage = 'agreementPostSuccessMessage';
        }

        const messages: string[] = [fields.find(x => x.name.toString() === postSuccessMessage).data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={messages} />
    }
    else if (deleteAccount) {
        const messages: string[] = [fields.find(x => x.name.toString() === 'accountDeleteSuccess').data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={messages} />
    }
    else if (mergeSuccess) {
        const messages: string[] = [fields.find(x => x.name.toString() === 'mergeSucessMessage').data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={messages} />
    }
    else if (exportSuccess) {
        const messages: string[] = [fields.find(x => x.name.toString() === 'exportSuccessMessage').data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={messages} />
    }
    else if (newAllocateDistributionPoolsJobSuccess) {
        return null;
    }
    else if (allocationJobInProgress) {
        const messages: string[] = [fields.find(x => x.name.toString() === 'allocationJobInProgress').data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Information} messages={messages} />
    }
    else if (processClaimJobSuccess){
        const messages: string[] = [fields.find(x => x.name.toString() === 'processClaimJobSuccessMessage').data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={messages} />
    }
    else if (newBookPriceCalculationsJobSuccess) {
        const messages: string[] = [fields.find(x => x.name.toString() === 'newBookPriceCalculationsJobSuccessMessage').data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={messages} />
    }
    else if (bookPriceCalculationsJobInProgress) {
        const messages: string[] = [fields.find(x => x.name.toString() === 'newBookPriceCalculationsJobSuccessMessage').data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Information} messages={messages} />
    }
    else if (saveSuccess && addRepresentationSuccessful !== undefined && !(addRepresentationSuccessful === true))
    {
        const messages: string[] = [fields.find(x => x.name.toString() === 'saveFailedMessage').data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Danger} messages={messages} />
    }
    else if (saveSuccess && componentInstance === LICENSE_MAINTENANCE_TOOLBAR && messages?.length === 1 && messages[0]?.messageKey === 'submitLicenseSuccessMessage')
    {
        const message: string[] = [fields.find(x => x.name.toString() === messages[0]?.messageKey).data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={message} />
    }
    else if (saveSuccess && componentInstance === WORK_MAINTENANCE_TOOLBAR && messages?.length === 1 && messages[0]?.messageKey === 'workAddtoPackageSuccessMessage')
    {
        const message: string[] = [fields.find(x => x.name.toString() === messages[0]?.messageKey).data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={message} />
    }
    else if (saveSuccess && componentInstance === PRODUCT_MAINTENANCE_TOOLBAR && messages?.length === 1 && messages[0]?.messageKey === 'productAddtoPackageSuccessMessage')
    {
        const message: string[] = [fields.find(x => x.name.toString() === messages[0]?.messageKey).data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={message} />
    }
    else if (saveSuccess && componentInstance === AGREEMENT_MAINTENANCE_TOOLBAR && messages?.length === 1 && messages[0]?.messageKey === 'agreementAddtoPackageSuccessMessage')
    {
        const message: string[] = [fields.find(x => x.name.toString() === messages[0]?.messageKey).data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={message} />
    }
    else if (saveSuccess && componentInstance === LICENSE_MAINTENANCE_TOOLBAR && messages?.length === 1 && messages[0]?.messageKey === 'submitLicenseFailureMessage') {
        const message: string[] = [fields.find(x => x.name.toString() === messages[0]?.messageKey).data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Danger} messages={message} />
    }   
    else if (mergeAgreementSuccess) {
        const messages: string[] = [fields.find(x => x.name.toString() === 'agreementMergeSuccessMessage').data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={messages} />
    }
    else if (agreementWorksFromPackageJobSuccess === true) {
        const baseMessage =
        fields.find(x => x.name.toString() === 'agreementWorksFromPackageJobSuccessMessage')?.data
        || 'Background job started to add works from package ${packageId}. Job ID: ${jobId}.';

        const message = baseMessage
            .replace('${packageId}', agreementWorksFromPackageJobResult?.packageId?.toString() || '')
            .replace('${jobId}', agreementWorksFromPackageJobResult?.jobId?.toString() || '');

        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={[message]} />
    }
    else if (agreementWorksFromPackageJobSuccess === false) {
        const message =
            fields.find(x => x.name.toString() === 'agreementWorksFromPackageJobFailureMessage')?.data
            || 'Failed to start background job to add works from package.';

        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Danger} messages={[message]} />
    }
    else {
        const messages: string[] = [fields.find(x => x.name.toString() === 'saveSuccessMessage')?.data];
        return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={messages} />
    }
}

export default connect(null, { showModal })(SaveResult);